/**
 * Como cada tipo de review se chama NA TELA — em toda a feature.
 *
 * Fica em core/ porque não é da listagem de reviews: a curadoria, o painel de custos e o
 * detalhe mostram o mesmo tipo. Eram quatro mapas paralelos, e nenhum deles conhecia os
 * tipos git — a mesma coisa com quatro nomes possíveis, e três telas mostrando o valor
 * cru.
 *
 * O valor de `resourceType` é identificador interno — viaja em coluna de banco, em chave
 * do S3 e em segmento de URL, e por isso é curto e minúsculo. Mostrá-lo cru entrega ao
 * usuário o vocabulário do banco: a listagem exibia `pullrequest` e passou a exibir
 * `pull` quando o tipo foi renomeado, porque o mapa de rótulos nunca teve os tipos git e
 * o fallback era o próprio valor.
 *
 * Um lugar só, e não um mapa por componente: a listagem e o detalhe mostram o mesmo
 * review, e dois mapas divergem no dia em que alguém acrescentar um tipo.
 */
const LABELS: Record<string, string> = {
  changeset: 'Changeset',
  comparison: 'Comparison',
  standalone: 'Standalone',
  issue: 'Issue',
  // Os termos são os do mercado, e são os mesmos que a jornada de "Novo Review" usa nos
  // cards: Pull Request é como GitHub, Bitbucket, Gitea e Azure DevOps chamam (só o
  // GitLab foge, com Merge Request), e Git Comparison está escrito em dois lugares do
  // wizard. Inventar um nome só para a listagem faria a mesma coisa ter dois nomes na
  // mesma tela.
  pull: 'Pull Request',
  commit: 'Commit',
  'git-comparison': 'Git Comparison',
  // As variantes -upload são detalhe da coluna resource_type: dizem que a entrada veio de
  // um upload em vez do provedor, e não são outro tipo de review. Aparecem no painel de
  // custos, que lê assistant_runs cru, e ali precisam do mesmo rótulo do tipo base.
  'comparison-upload': 'Comparison',
  'standalone-upload': 'Standalone'
};

/**
 * Rótulo do tipo. Tipo desconhecido devolve o próprio valor — é feio, mas diagnosticável,
 * e melhor que uma tela em branco quando o backend passa a mandar algo novo.
 */
export function resourceTypeLabel(resourceType?: string): string {
  const key = (resourceType || '').trim().toLowerCase();
  if (!key) { return ''; }
  return LABELS[key] ?? key;
}
